import { t } from "@lingui/core/macro";
import { TaxSystem } from "@/server-types";

export function getTaxPercentageValues(taxSystem: TaxSystem) {
  if (taxSystem === "fina") {
    return [0, 5, 13, 25];
  }

  return [0, 9.5, 22];
}

// The standard (highest) rate for a tax system — furs 22%, fina 25%. Used as the
// default when seeding a custom subscription's tax rate so the value follows the
// client's fiscalization system instead of being hardcoded to a single country's rate.
export function getDefaultTaxPercentage(taxSystem: TaxSystem) {
  const values = getTaxPercentageValues(taxSystem);
  return values[values.length - 1] ?? 0;
}

export function getTaxPercentageItems(taxSystem: TaxSystem) {
  return getTaxPercentageValues(taxSystem).map((taxPercentage) => {
    return {
      key: String(taxPercentage),
      label: getTaxPercentageLabel(taxPercentage),
    };
  });
}

function getTaxPercentageLabel(taxPercentage: number) {
  switch (taxPercentage) {
    case 0:
      return t`(0%) Brez DDV`;
    case 5:
      return t`(5%) Znižana stopnja`;
    case 9.5:
      return t`(9.5%) Znižana stopnja`;
    case 13:
      return t`(13%) Znižana stopnja`;
    case 22:
      return t`(22%) Standardna stopnja`;
    case 25:
      return t`(25%) Standardna stopnja`;
    default:
      return `(${taxPercentage}%)`;
  }
}
